import React from 'react';
import api from '../api/axios';

const PaymentButton = ({ business, onPaymentSuccess }) => {
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    const res = await loadRazorpayScript();
    if (!res) {
      alert('Razorpay SDK failed to load. Are you online?');
      return;
    }

    try {
      const orderResponse = await api.post('/payment/create_order', { business_id: business.id });
      const { amount, order_id, razorpay_key, business_name } = orderResponse.data;

      const options = {
        key: razorpay_key,
        amount: amount,
        currency: 'INR',
        name: 'THTMG Subscription',
        description: `Payment for ${business_name}`,
        order_id: order_id,
        handler: async function (response) {
          try {
            await api.post('/payment/verify_payment', {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
            });
            alert('Payment successful!');
            onPaymentSuccess();
          } catch (verifyError) {
            console.error('Payment verification failed:', verifyError);
            alert('Payment verification failed.');
          }
        },
        prefill: {
            // You can prefill user data here
        },
        theme: {
          color: '#F37254',
        },
      };
      
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

    } catch (error) {
      console.error('Error creating payment order:', error);
      alert('Could not initiate payment.');
    }
  };

  return (
    <button onClick={handlePayment} className="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-3 rounded text-sm">
      Pay ₹1000
    </button>
  );
};

export default PaymentButton;